import email from 'assets/icons/email_icon.svg'
import telegram from 'assets/icons/telegram.svg'
import twitter from 'assets/icons/twitter.svg'
import medium from 'assets/icons/medium.svg'
import press from 'assets/icons/press_icon.svg'
import discord from 'assets/social/discord.svg'
import tiktok from 'assets/social/tiktok_icon.svg'
import reddit from 'assets/icons/reddit_icon.svg'

export const brands = {
  email,
  medium,
  telegram,
  twitter,
  press,
  discord,
  tiktok,
  reddit,
}
